import { render, staticRenderFns } from "./CriteriaPreview.vue?vue&type=template&id=4888796d&"
import script from "./CriteriaPreview.vue?vue&type=script&lang=ts&"
export * from "./CriteriaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CriteriaPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports